import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineSpecialProcessesSchema: CollectionCreateSchema = {
  name: CollectionName.WineSpecialProcesses,
  fields: [
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
